import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'wm-external-data-connections-editor',
    templateUrl: './external-data-connections-editor.component.html',
    styleUrls: ['./external-data-connections-editor.component.css'],
    standalone: false
})
export class ExternalDataConnectionsEditorComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
